import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Link as RouterLink } from 'react-router-dom'
import {
  Tab as UnstyledTab,
  TabList as UnstyledTabList,
  Tabs as UnstyledTabs,
  TabPanel as UnstyledTabPanel
} from 'react-tabs'

const linkStyles = ({ theme }) => css`
  label: link;

  font-size: ${theme.typography.text.kilo.fontSize};
`

export const Link = styled(RouterLink)(linkStyles)

const tabsStyles = () => css`
  label: tabs;

  background: transparent;
`

export const Tabs = styled(UnstyledTabs)(tabsStyles)

const tabListStyle = ({ theme }) => css`
  label: tab__list;

  display: flex;
  margin: 0;
  margin-bottom: ${theme.spacings.giga};
`

export const TabList = styled(UnstyledTabList)(tabListStyle)

const tabStyle = ({ theme }) => css`
  label: tab;

  border-bottom: ${theme.spacings.bit} solid ${theme.colors.n200};
  color: ${theme.colors.n800};
  cursor: pointer;
  font-size: ${theme.typography.text.kilo.fontSize};
  margin: 0;
  padding: ${theme.spacings.byte} 0;
  text-align: left;

  &:first-of-type {
    margin-right: ${theme.spacings.mega};
  }

  &.selected {
    border-color: ${theme.colors.v500};
    color: ${theme.colors.v500};
  }

  ${theme.media.mega} {
    font-size: ${theme.typography.text.mega.fontSize};
  }
`

export const Tab = styled(UnstyledTab)(tabStyle)

const tabPanelStyle = () => css`
  label: tab__panel;

  display: none;

  &.selected {
    display: block;
  }
`

export const TabPanel = styled(UnstyledTabPanel)(tabPanelStyle)

const tabBadgeStyle = ({ theme }) => css`
  label: tab__bagde;

  background: linear-gradient(
    150deg,
    ${theme.colors.f600} 35%,
    ${theme.colors.v500} 100%
  );
  border-radius: 25px;
  color: ${theme.colors.white};
  display: inline-block;
  font-size: ${theme.typography.text.kilo.fontSize};
  font-weight: ${theme.font.weight.semibold};
  margin-left: ${theme.spacings.byte};
  padding: ${theme.spacings.bit} ${theme.spacings.byte};
  pointer-events: none;
  text-align: center;
`

export const TabBadge = styled('span')(tabBadgeStyle)

Tab.tabsRole = 'Tab'
Tabs.tabsRole = 'Tabs'
TabPanel.tabsRole = 'TabPanel'
TabList.tabsRole = 'TabList'
